import * as R from 'ramda'

import invoiceSchema from '~/src/invoice/data/invoices/schema.js'

import schema from '../retailOrder/schema.js'
import { FORM_FIELDS } from '../retailOrder/awardTypes.js'

// The three boxes the staff types an award into.
//
// THEY BELONG TO THE VIEW, NOT THE MODEL. They are screen state -- awardIntake
// turns them into the order's `awards` array and strips them before the model
// layer sees the values -- so the only thing that needs to know their shape is
// the form. coact builds its field dictionary by traversing the VIEW schema,
// which is how `invoices` below has always been renderable without existing on
// the `retailOrders` model at all.
//
// Declaring them on the model schema instead did not store the staff's input,
// it stored three objects of nulls on every order: codev gives every optional
// leaf a `default: null` and fills it on insert, so stripping the values was
// never the last word. See the note where they used to live, in
// ../retailOrder/schema.
//
// LABELS COME FROM awardTypes, which already names these boxes for the intake
// table -- so a renamed field is renamed once.
const awardInput = ({ label }) => ({
  type: 'Object',
  contents: {
    value: { type: 'Number', label },
    note: { type: 'String', label: `${label}備註` },
  },
})

const awardInputs = R.fromPairs(
  FORM_FIELDS.map(field => [field.path, awardInput(field)]),
)

// The flags saying a staffer overrode a suggested value, for the boxes that
// have a suggestion. Screen state, exactly like the boxes: computeEarnPoints
// writes one on every keystroke, long before any award exists, and awardIntake
// strips it before the write. The FACT it records is frozen onto the award as
// `force` -- see ../retailOrder/schema.
const forceInputs = R.fromPairs(
  FORM_FIELDS.filter(field => field.forcePath).map(field => [
    field.forcePath,
    { type: 'Boolean', label: `${field.label}強制填寫` },
  ]),
)

const viewSchema = R.pipe(
  R.assocPath(['contents', 'items'], {
    type: 'Array',
    contents: [schema.item],
  }),
  R.assocPath(['contents', 'invoices'], {
    type: 'Array',
    contents: [invoiceSchema],
  }),
  header =>
    R.assoc(
      'contents',
      { ...header.contents, ...awardInputs, ...forceInputs },
      header,
    ),
)(schema.header)

export default viewSchema
